import n from './notifications_reducer'

export default n